import { render, staticRenderFns } from "./MembersPortfolio.vue?vue&type=template&id=37dd2c3d&scoped=true&"
import script from "./MembersPortfolio.vue?vue&type=script&lang=js&"
export * from "./MembersPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./MembersPortfolio.vue?vue&type=style&index=0&id=37dd2c3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd2c3d",
  null
  
)

export default component.exports